import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'utils/helper';
import Icons from '../Icons';
import LoadingSpinner from '../LoadingSpinner';

const Button = ({
  caption,
  type,
  disabled,
  icon,
  bgColor,
  busy,
  rightIcon = '',
  className: cls = 'p-3',
  onClick,
}) => {
  const className = useMemo(
    () =>
      `${(bgColor && `bg-${bgColor}`) || ''} btn ${
        disabled ? 'btn-disabled' : `btn-${type}`
      } ${(caption && 'has-caption') || ''} ${cls || ''}`,
    [type, disabled, cls]
  );
  const Icon = icon !== '' ? Icons[icon] : null;
  const RightIcon = rightIcon !== '' ? Icons[rightIcon] : null;

  return (
    <button className={className} onClick={onClick} disabled={disabled || busy}>
      {busy ? (
        <LoadingSpinner size="25px" />
      ) : (
        <>
          {Icon && <Icon />}
          {caption}
          {RightIcon && <RightIcon />}
        </>
      )}
    </button>
  );
};

Button.propTypes = {
  caption: PropTypes.string,
  type: PropTypes.string, // primary, secondary, neutral, flat
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  caption: '',
  type: 'primary',
  disabled: false,
  icon: '',
  onClick: noop,
};

export default Button;
